export default __webpack_public_path__ + "img/warn.16b23e6.svg";